export default __webpack_public_path__ + "mtv.de6f5c37.png";